document.addEventListener('DOMContentLoaded', function() {
  const popularLinks = document.querySelectorAll('.popular-items li a');
  const headerHeight = document.querySelector('header').offsetHeight + 50;

  popularLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      
      if (targetElement) {
        document.querySelectorAll('.faq-container').forEach(container => container.classList.remove('open'));
        document.querySelectorAll('.panel_content').forEach(panel => panel.classList.remove('open'));

        const faqContainer = targetElement.closest('.faq-container');
        const panelContent = targetElement.querySelector('.panel_content');
 
        setTimeout(() => {
          const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });

          setTimeout(() => {
            if (faqContainer) faqContainer.classList.add('open');
            if (panelContent) panelContent.classList.add('open');
          }, 100);
        }, 300);
      }
    });
  });

  function applySearch(searchline) {
    document.querySelector("[data-faq-form] input").value = searchline;
    document.querySelector('.popular-items').classList.add('d-none');
    const faqBlocks = document.querySelectorAll("[data-faq-blocks]");
    const searchLower = searchline.toLowerCase();
    faqBlocks.forEach(function (block) {
      var text = (block.textContent || block.innerText).trim().toLowerCase();
      const answer = block.querySelector('[data-faq-answer]');
      if (text.indexOf(searchLower) > -1) {
        block.style.display = "block";
        block.classList.add("open");
        if (answer) answer.classList.add("open");
      } else {
        block.style.display = "none";
        block.classList.remove("open");
        if (answer) answer.classList.remove("open");
      }
    });
  }

  // Prevent page reload on tag clicks
  document.querySelectorAll('.badge-tags a').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const url = new URL(this.href);
      const searchline = url.searchParams.get('searchline');
      if (searchline) {
        window.history.pushState({}, '', this.href);
        applySearch(searchline);
      }
    });
  });

  // Handle initial page load with search parameter
  const urlParams = new URLSearchParams(window.location.search);
  const searchline = urlParams.get("searchline");
  if (searchline) applySearch(searchline);
});